import { api } from "api/api";
import { AxiosError } from "axios";
import Usuario from "model/administracao/cadastro/Usuario";
import GrupoUsuarios from "model/administracao/cadastro/GrupoUsuarios";
import Page from "model/page/Page";
import Pageable from "model/page/Pageable";
import { BaseServiceCadastros } from "service/BaseServiceCadastros";
import { getFilters } from "utils/filterUtils";
import { DataTableFilterMeta } from "primereact/datatable";
import PlanoAuditoria from "model/auditoria5s/planoDeAuditoria/PlanoAuditoria";
import { generateKey } from "utils/generateKey";
import GrupoUsuariosUsuario from "model/administracao/cadastro/GrupoUsuariosUsuario";

class GrupoUsuariosService implements BaseServiceCadastros<GrupoUsuarios> {

    pesquisar(page: Pageable, filters?: DataTableFilterMeta | null) {
        return new Promise<Page>((resolve, reject): void => {
            let url = `/grupoUsuarios/pesquisar`;
            url += getFilters(filters)
            const params = {
                page: page.page,
                size: page.size,
                sort: page.sort,
            };

            api
                .get(url, { params })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    consultar(id: number) {
        return new Promise<GrupoUsuarios>((resolve, reject): void => {
            api
                .get(`/grupoUsuarios/consultar/${id}`)
                .then(response => {
                    const grupoUsuarios: GrupoUsuarios = response.data;

                    grupoUsuarios.itens.forEach((item: GrupoUsuariosUsuario) => {
                        item.key = generateKey();
                    });

                    resolve(grupoUsuarios)
                })
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    incluir(grupoUsuarios: GrupoUsuarios) {
        return new Promise<GrupoUsuarios>((resolve, reject): void => {
            api
                .post(`/grupoUsuarios/incluir`, JSON.stringify(grupoUsuarios))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    editar(grupoUsuarios: GrupoUsuarios) {
        return new Promise<GrupoUsuarios>((resolve, reject): void => {
            api
                .put(`/grupoUsuarios/editar`, JSON.stringify(grupoUsuarios))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    excluir(id: number) {
        return new Promise<void>((resolve, reject): void => {
            api
                .delete(`/grupoUsuarios/excluir/${id}`)
                .then(() => resolve())
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    usuarios() {
        return new Promise<Array<Usuario>>((resolve, reject): void => {
            let url = `/grupoUsuarios/usuarios`;
            api
                .get(url)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }
}

export default GrupoUsuariosService;
